import { handleActions, combineActions } from 'redux-actions'
import {
  actionsTypesGenerator,
  onRequest,
  onSuccess,
  onFailure,
} from 'utils/reduxHelpers'
import initialState from '../initialState'

const namespace = 'FAVORITES'

const FETCH_FAVORITES_VIDEOS = actionsTypesGenerator(
  `FETCH_${namespace}_VIDEOS`
)
const FETCH_FAVORITES_SEQUENCES = actionsTypesGenerator(
  `FETCH_${namespace}_SEQUENCES`
)

const ADD_VIDEO_TO_FAVORITES = actionsTypesGenerator(
  `ADD_VIDEO_TO_${namespace}`
)
const ADD_SEQUENCE_TO_FAVORITES = actionsTypesGenerator(
  `ADD_SEQUENCE_TO_${namespace}`
)

const DELETE_VIDEO_FROM_FAVORITES = actionsTypesGenerator(
  `DELETE_VIDEO_FROM_${namespace}`
)
const DELETE_SEQUENCE_FROM_FAVORITES = actionsTypesGenerator(
  `DELETE_SEQUENCE_FROM_${namespace}`
)

export const fetchFavoritesVideos = params => ({
  types: FETCH_FAVORITES_VIDEOS,
  callAPI: {
    method: 'GET',
    entity: 'Favorites Videos',
    path: '/favorites/videos',
    params,
  },
  payload: {
    entity: 'videos',
  },
})

export const fetchFavoritesSequences = () => ({
  types: FETCH_FAVORITES_SEQUENCES,
  callAPI: {
    method: 'GET',
    entity: 'Favorites Sequences',
    path: '/favorites/sequences',
  },
  payload: {
    entity: 'sequences',
  },
})

export const addVideoToFavorites = id => ({
  types: ADD_VIDEO_TO_FAVORITES,
  callAPI: {
    method: 'POST',
    entity: 'Favorite Video',
    path: `/favorites/videos/${id}`,
  },
  payload: {
    entity: 'videos',
  },
})

export const addSequenceToFavorites = id => ({
  types: ADD_SEQUENCE_TO_FAVORITES,
  callAPI: {
    method: 'POST',
    entity: 'Favorite Sequence',
    path: `/favorites/sequences/${id}`,
  },
  payload: {
    entity: 'sequences',
  },
})

export const deleteVideoFromFavorites = id => ({
  types: DELETE_VIDEO_FROM_FAVORITES,
  callAPI: {
    method: 'DELETE',
    entity: 'Favorite Video',
    path: `/favorites/videos/${id}`,
  },
  payload: {
    entity: 'videos',
  },
})

export const deleteSequenceFromFavorites = id => ({
  types: DELETE_SEQUENCE_FROM_FAVORITES,
  callAPI: {
    method: 'DELETE',
    entity: 'Favorite Sequence',
    path: `/favorites/sequences/${id}`,
  },
  payload: {
    entity: 'sequences',
  },
})

export default handleActions(
  {
    [combineActions(
      FETCH_FAVORITES_VIDEOS.request,
      FETCH_FAVORITES_SEQUENCES.request,
      ADD_VIDEO_TO_FAVORITES.request,
      ADD_SEQUENCE_TO_FAVORITES.request,
      DELETE_VIDEO_FROM_FAVORITES.request,
      DELETE_SEQUENCE_FROM_FAVORITES.request
    )]: onRequest,
    [combineActions(
      FETCH_FAVORITES_VIDEOS.success,
      FETCH_FAVORITES_SEQUENCES.success,
      ADD_VIDEO_TO_FAVORITES.success,
      ADD_SEQUENCE_TO_FAVORITES.success,
      DELETE_VIDEO_FROM_FAVORITES.success,
      DELETE_SEQUENCE_FROM_FAVORITES.success
    )]: (state, { response: { data = [] }, entity }) =>
      onSuccess({
        ...state,
        items: {
          ...state.items,
          [entity]: data,
        },
      }),
    [combineActions(
      FETCH_FAVORITES_VIDEOS.failure,
      FETCH_FAVORITES_SEQUENCES.failure,
      ADD_VIDEO_TO_FAVORITES.failure,
      ADD_SEQUENCE_TO_FAVORITES.failure,
      DELETE_VIDEO_FROM_FAVORITES.failure,
      DELETE_SEQUENCE_FROM_FAVORITES.failure
    )]: onFailure,
  },
  initialState.favorites
)
